import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import * as Card from '../../Card'
import * as Content from '../../Content'
import * as Form from '../../Form'
import * as Navigation from '../../Navigation'
import * as Responsive from '../../Responsive'
import { PaddedContent } from '../../Layout'

interface IErrorViewProps {
  error?: string
}

/**
 * Renders a summary of an error so that a user can contact
 * support with more details or get back to the previous
 * view.
 */
export const ErrorView: React.FC<IErrorViewProps> = ({ error }) => {
  // Drawer appearance
  const { useDisplayMode } = useContext(Responsive.DrawerManagerContext)
  useDisplayMode('expanded')
  const navigate = useNavigate()
  const goBack = () => navigate(-1)

  return (
    <PaddedContent>
      <Content.Body>
        <Navigation.ReturnLink to="#" onClick={goBack}>
          Go Back
        </Navigation.ReturnLink>
      </Content.Body>

      <Content.Heading>An Unexpected Error Has Occurred</Content.Heading>
      <Content.Body>
        Please notify our support team of this issue so that we can further
        address it if necessary.
      </Content.Body>
      <Form.Divider />

      <Card.View>
        <div className="flex flex-col m-0 box-border p-2 max-w-full overflow-x-auto">
          <Content.Code style={{ overflowX: 'auto' }}>
            {error ?? 'Unknown error'}
          </Content.Code>
        </div>
      </Card.View>
    </PaddedContent>
  )
}
